import cn from 'classnames'

import toast, { Toast, ToastBar, Toaster } from 'react-hot-toast'

import AlertIcon from 'src/icons/alert.svg'
import CloseIcon from 'src/icons/close.svg'
import InfoIcon from 'src/icons/info.svg'
import SuccessIcon from 'src/icons/success.svg'

import { ExtendedToastOptions } from '../model/types'
import styles from './styles.module.scss'
import { useMediaQuery } from 'src/lib/use-media-query'

const CloseButton = ({ id }: { id: string }) => (
    <button
        aria-label="close"
        className={styles.close_btn}
        onClick={() => toast.dismiss(id)}
    >
        <img src={CloseIcon} alt="CloseIcon" className="toast-icon" />
    </button>
)

export const ToasterComponent = () => {
    const isMobile = useMediaQuery('(max-width: 1024px)')

    return (
        <Toaster
            toastOptions={{ className: 'toast', duration: 2 * 1000 }}
            containerClassName={'toast-container'}
            position={isMobile ? 'top-center' : 'top-right'}
        >
            {(toast: Toast & ExtendedToastOptions) => {
                switch (toast.type) {
                    case 'success':
                        return (
                            <div
                                className={cn(
                                    styles.root,
                                    toast.visible ? styles.show : styles.hide
                                )}
                            >
                                <div className={styles.icon_container}>
                                    <img
                                        src={SuccessIcon}
                                        alt="SuccessIcon"
                                        className="toast-icon"
                                    />
                                </div>
                                <div className={styles.content}>
                                    <p
                                        className={cn(
                                            styles.label,
                                            styles.success_label
                                        )}
                                    >
                                        {toast.title ?? 'Success'}
                                    </p>
                                    <p className={styles.message}>
                                        {toast.message as string}
                                    </p>
                                </div>
                                <div className={styles.close_container}>
                                    <CloseButton id={toast.id} />
                                </div>
                            </div>
                        )
                    case 'error':
                        return (
                            <div
                                className={cn(
                                    styles.root,
                                    toast.visible ? styles.show : styles.hide
                                )}
                            >
                                <div className={styles.icon_container}>
                                    <img
                                        src={AlertIcon}
                                        alt="AlertIcon"
                                        className="toast-icon"
                                    />
                                </div>
                                <div className={styles.content}>
                                    <p
                                        className={cn(
                                            styles.label,
                                            styles.error_label
                                        )}
                                    >
                                        {toast.title ?? 'Error'}
                                    </p>
                                    <p className={styles.message}>
                                        {toast.message as string}
                                    </p>
                                </div>
                                <div className={styles.close_container}>
                                    <CloseButton id={toast.id} />
                                </div>
                            </div>
                        )
                    case 'loading':
                        return (
                            <div
                                className={cn(
                                    styles.root,
                                    toast.visible ? styles.show : styles.hide
                                )}
                            >
                                <div className={styles.icon_container}>
                                    <img
                                        src={InfoIcon}
                                        alt="InfoIcon"
                                        className="toast-icon"
                                    />
                                </div>
                                <div className={styles.content}>
                                    <p
                                        className={cn(
                                            styles.label,
                                            styles.loading_label
                                        )}
                                    >
                                        {toast.title ?? 'Pending'}
                                    </p>
                                    <p className={styles.message}>
                                        {toast.message as string}
                                    </p>
                                </div>
                                <div className={styles.close_container}>
                                    <CloseButton id={toast.id} />
                                </div>
                            </div>
                        )
                    default:
                        return <ToastBar toast={toast} />
                }
            }}
        </Toaster>
    )
}
